import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RoutesGlossary } from "../common/glossary/routes-glossary";

import { AuthComponent } from "./app/components/auth.component";
import { HomeComponent } from "../home/app/components/home.component";
import { WebAdminComponent } from "../web-admin/app/components/web-admin.component";

const routes: Routes = [
    {
        path: RoutesGlossary.Same,
        component: HomeComponent,
    },
    {
        path: RoutesGlossary.Login,
        component: AuthComponent,
    },
    {
        path: RoutesGlossary.LoginDomain,
        component: AuthComponent,
    },
    {
        path: RoutesGlossary.GetKrbUser,
        component: AuthComponent,
    },
    {
        path: RoutesGlossary.WebAdmin,
        component: WebAdminComponent,
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {

}